import React, { useEffect, useState } from 'react';
import styles from './ChatLogos.module.scss';
import classNames from 'classnames';
import usePortalAuth from '../../hooks/usePortalAuth';


const ChatLogos : React.FC = () => {
    const auth = usePortalAuth();

    const [iframeDimensions, setIframeDimensions] = useState<any>({
        largura: 0,
        altura: 0,
    });
    const [chatMinimizado, setChatMinimizado] = useState(false); // Assume que começa maximizado
    const [maximizado, setMaximizado] = useState(false); // Novo estado para classe maximizada


    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (!event.data || !event.data.tipo) return;
            console.log('Mensagem recebida do iframe:', event.data);

            if (event.data.tipo === 'resize-chat-logos') {
                const { largura: larguraRecebida, altura: alturaRecebida, minimizado } = event.data;
                setChatMinimizado(minimizado);
                if (minimizado) {
                    setIframeDimensions({
                        largura: `300px`,
                        altura: `70px`
                    });
                } else {
                    setIframeDimensions({
                        largura: null,
                        altura: null,
                    });
                }
            } else if (event.data.tipo === 'maximizar-chat-logos') {
                setChatMinimizado(false);
                setMaximizado(true);
            } else if (event.data.tipo === 'minimizar-chat-logos') {
                setChatMinimizado(false);   
                setMaximizado(false);
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []); // Array de dependências vazio

    // Função para construir o objeto de estilo do iframe
    const getIframeStyle = () => {
        const style : any = {
            border: 'none', // Estilo base
            transition: 'width 0.3s ease, height 0.3s ease, border-radius 0.3s ease', // Estilo base e transição para border-radius
        };

        if (iframeDimensions.largura !== null) {
            style.width = iframeDimensions.largura;
        }
        if (iframeDimensions.altura !== null) {
            style.height = iframeDimensions.altura;
        }

        // Adiciona o border-radius se o chat estiver minimizado
        if (chatMinimizado) {
            style.borderRadius = '50em';
        } else if (iframeDimensions.largura === '100vw' && iframeDimensions.altura === '100vh') {
            style.borderRadius = '0'; // Tela cheia, sem borda arredondada
        } else {
            style.borderRadius = '0'; // Ou o valor padrão quando maximizado, se houver
        }
        return style;
    };


    return <>{auth.isAuthenticated && <iframe
                src={`https://sisweb.tesouro.gov.br/apex/f?p=60122:2:::::P2_SN_MINIMIZADO,P2_SN_FLUTUANTE:S,N&token_azure=${auth.user?.access_token}`}
                title="Chat"
                id="frame-chat-logos"
                className={classNames(
                    styles['chat-flutuante'],
                    maximizado ? styles['chat-flutuante--maximizado'] : '',
                )}
                style={getIframeStyle()}
            ></iframe>}
            </>;
}

export default ChatLogos;